"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var TeamTableRow_1 = __importDefault(require("./styles/TeamTableRow"));
var TeamRowDetails_1 = __importDefault(require("./TeamRowDetails"));
var TeamsRow = function (_a) {
    var item = _a.item, onClickRow = _a.onClickRow, selectedItem = _a.selectedItem;
    var _b = __read(react_1.default.useState(false), 2), inputActive = _b[0], setInputActive = _b[1];
    // undefined means noneSelected, the 3 options undefined, true and false all have different styles
    return ((0, jsx_runtime_1.jsx)(TeamTableRow_1.default
    // selected={selectedItem ? item?.id === selectedItem.id : undefined}
    , __assign({ 
        // selected={selectedItem ? item?.id === selectedItem.id : undefined}
        isActive: inputActive, isClickable: true }, { children: (0, jsx_runtime_1.jsx)(TeamRowDetails_1.default, { item: item, onClickRow: function (selectedTeam) { return onClickRow(selectedTeam); }, isPartialView: !!selectedItem, setInputActive: setInputActive }) })));
};
exports.default = react_1.default.memo(TeamsRow);
